import * as Types from '../../types';

import { gql } from '@apollo/client';
import { AddressDisplayFragmentDoc } from '../../components/AddressDisplay/AddressDisplay.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetTransactionQueryVariables = Types.Exact<{
  hash: Types.Scalars['String']['input'];
}>;

export type GetTransactionQuery = {
  __typename?: 'Query';
  transaction?: {
    __typename?: 'Transaction';
    hash: string;
    nonce: number;
    transactionIndex?: number | null;
    value: Array<number>;
    valueEth: any;
    gas: number;
    gasPrice?: any | null;
    maxFeePerGas?: any | null;
    maxPriorityFeePerGas?: any | null;
    maxFeePerBlobGas?: any | null;
    input: string;
    chainId?: number | null;
    status: Types.TransactionStatus;
    blockNumber?: number | null;
    blockHash?: string | null;
    createdAt: any;
    to?: {
      __typename?: 'Address';
      address: string;
      entity?: {
        __typename?: 'Entity';
        id: any;
        name: string;
        risks: {
          __typename?: 'EntityRiskConnection';
          totalCount: number;
          pageInfo: {
            __typename?: 'PageInfo';
            hasNextPage: boolean;
            hasPreviousPage: boolean;
            startCursor?: string | null;
            endCursor?: string | null;
          };
          edges: Array<{
            __typename?: 'EntityRiskEdge';
            node: {
              __typename?: 'EntityRisk';
              id: any;
              riskType: string;
              severity: string;
              description?: string | null;
            };
          }>;
        };
      } | null;
      risks: {
        __typename?: 'AddressRiskConnection';
        totalCount: number;
        pageInfo: {
          __typename?: 'PageInfo';
          hasNextPage: boolean;
          hasPreviousPage: boolean;
          startCursor?: string | null;
          endCursor?: string | null;
        };
        edges: Array<{
          __typename?: 'AddressRiskEdge';
          node: {
            __typename?: 'AddressRisk';
            id: any;
            riskType: string;
            severity: string;
            description?: string | null;
          };
        }>;
      };
    } | null;
    from: {
      __typename?: 'Address';
      address: string;
      entity?: {
        __typename?: 'Entity';
        id: any;
        name: string;
        risks: {
          __typename?: 'EntityRiskConnection';
          totalCount: number;
          pageInfo: {
            __typename?: 'PageInfo';
            hasNextPage: boolean;
            hasPreviousPage: boolean;
            startCursor?: string | null;
            endCursor?: string | null;
          };
          edges: Array<{
            __typename?: 'EntityRiskEdge';
            node: {
              __typename?: 'EntityRisk';
              id: any;
              riskType: string;
              severity: string;
              description?: string | null;
            };
          }>;
        };
      } | null;
      risks: {
        __typename?: 'AddressRiskConnection';
        totalCount: number;
        pageInfo: {
          __typename?: 'PageInfo';
          hasNextPage: boolean;
          hasPreviousPage: boolean;
          startCursor?: string | null;
          endCursor?: string | null;
        };
        edges: Array<{
          __typename?: 'AddressRiskEdge';
          node: {
            __typename?: 'AddressRisk';
            id: any;
            riskType: string;
            severity: string;
            description?: string | null;
          };
        }>;
      };
    };
  } | null;
};

export const GetTransactionDocument = gql`
  query GetTransaction($hash: String!) {
    transaction(hash: $hash) {
      hash
      nonce
      transactionIndex
      to {
        ...AddressDisplay
      }
      from {
        ...AddressDisplay
      }
      value
      valueEth
      gas
      gasPrice
      maxFeePerGas
      maxPriorityFeePerGas
      maxFeePerBlobGas
      input
      chainId
      status
      blockNumber
      blockHash
      createdAt
    }
  }
  ${AddressDisplayFragmentDoc}
`;

/**
 * __useGetTransactionQuery__
 *
 * To run a query within a React component, call `useGetTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionQuery({
 *   variables: {
 *      hash: // value for 'hash'
 *   },
 * });
 */
export function useGetTransactionQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetTransactionQuery,
    GetTransactionQueryVariables
  > &
    (
      | { variables: GetTransactionQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTransactionQuery, GetTransactionQueryVariables>(
    GetTransactionDocument,
    options,
  );
}
export function useGetTransactionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetTransactionQuery,
    GetTransactionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTransactionQuery, GetTransactionQueryVariables>(
    GetTransactionDocument,
    options,
  );
}
export function useGetTransactionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetTransactionQuery,
        GetTransactionQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetTransactionQuery,
    GetTransactionQueryVariables
  >(GetTransactionDocument, options);
}
export type GetTransactionQueryHookResult = ReturnType<
  typeof useGetTransactionQuery
>;
export type GetTransactionLazyQueryHookResult = ReturnType<
  typeof useGetTransactionLazyQuery
>;
export type GetTransactionSuspenseQueryHookResult = ReturnType<
  typeof useGetTransactionSuspenseQuery
>;
export type GetTransactionQueryResult = Apollo.QueryResult<
  GetTransactionQuery,
  GetTransactionQueryVariables
>;
